export enum CtaType {
  APPLY_NOW_BUTTON = 'apply_now_button',
  INSTITUTION_IMAGE = 'institution_image',
  INSTITUTION_NAME = 'institution_name',
  INSTITUTION_WEBSITE_LINK = 'institution_website_link',
  NOT_APPLICABLE = 'not_applicable',
  OFFER_LINK = 'offer_link',
  OFFER_NAME = 'offer_name',
  PRODUCT_IMAGE = 'product_image',
  PRODUCT_NAME = 'product_name',
  RATES_AND_FEES_TEXT = 'rates_and_fees_text',
  REST_OF_PRODUCT_CARD = 'rest_of_product_card',
}

export const ALL_CTA_TYPES = Object.values(CtaType);

export const normalizeCtaType = (ctaType: string): CtaType | undefined => {
  const lowerCaseCtaType = ctaType.toLowerCase();
  if (lowerCaseCtaType === 'apply_link') {
    return CtaType.OFFER_LINK;
  }
  return ALL_CTA_TYPES.find((type) => type === ctaType);
};
